import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import {Alert} from "reactstrap";

/**
 * Třída pro zobrazení globálních validačních chyb na formuláři.
 *
 * Použití:
 * const {error} = this.props;
 * {error && <ValidationErrors error={error}/>}
 */
export default class ValidationErrors extends AbstractReactComponent {
    static PropTypes = {
        error: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
    };

    render() {
        const {error, className} = this.props;

        if (Array.isArray(error)) {
            const rows = error.map(err => <div>{err}</div>);
            return <Alert color="danger" className={className}>{rows}</Alert>;
        } else {
            return <Alert color="danger" className={className}>{error}</Alert>;
        }
    }
}
